export const DeleteMenuIcon = ({
  strokeColor = "var(--color-red-2)",
  ...props
}: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M6.66667 7.33328V11.3336M9.33333 7.33328V11.3336M12.6667 3.99968V13.3338C12.6667 13.6874 12.5262 14.0266 12.2761 14.2766C12.0261 14.5267 11.687 14.6672 11.3333 14.6672H4.66667C4.31304 14.6672 3.97391 14.5267 3.72386 14.2766C3.47381 14.0266 3.33333 13.6874 3.33333 13.3338V3.99968M2 3.99968H14M5.33333 3.99968V2.66624C5.33333 2.31259 5.47381 1.97342 5.72386 1.72336C5.97391 1.47329 6.31304 1.3328 6.66667 1.3328H9.33333C9.68696 1.3328 10.0261 1.47329 10.2761 1.72336C10.5262 1.97342 10.6667 2.31259 10.6667 2.66624V3.99968"
      stroke={strokeColor}
      strokeLinecap="round"
    />
  </svg>
);
